import { Box } from '@mui/material';
import { DataCellProps } from '../types';
import { formatApproval, REALM_ARCHIVED_LABEL } from '../helpers';

export const DataDeletionSupportApprovalCell = ({ team }: DataCellProps) => {
  return (
    <Box>
      {team.realmArchived
        ? REALM_ARCHIVED_LABEL
        : formatApproval(team.supportApproved, team.supportApprover, team.supportApprovedAt)}
    </Box>
  );
};
